import { FC } from 'react';
import styled from 'styled-components';

export interface EmptyPageProps {
    image: JSX.Element;
    title: string;
    description: string;
    button?: JSX.Element;
    backgroundColor?: string;
    fullScreen?: boolean;
};

const Wrapper = styled.div<{ $fullScreen?: boolean; $backgroundColor?: string }>`
    width: ${({ $fullScreen }) => $fullScreen ? '100%' : 'auto'};
    min-height: ${({ $fullScreen }) => $fullScreen ? 'calc(100vh - 64px)' : 'auto'};
    display: ${({ $fullScreen }) => $fullScreen ? 'flex' : 'block'};
    justify-content: ${({ $fullScreen }) => $fullScreen ? 'center' : 'normal'};
    align-items: ${({ $fullScreen }) => $fullScreen ? 'center' : 'normal'};
    background-color: ${({ $fullScreen, $backgroundColor }) => $fullScreen ? ($backgroundColor ?? 'transparent') : 'transparent'};
`;

const DIV = styled.div<{ $backgroundColor?: string; $fullScreen?: boolean }>`
    position: ${({ $fullScreen }) => $fullScreen ? 'relative' : 'absolute'};
    top: ${({ $fullScreen }) => $fullScreen ? 'auto' : 'calc(50% + 55px)'};
    left: ${({ $fullScreen }) => $fullScreen ? 'auto' : 'calc(50% + 43px)'};
    transform: ${({ $fullScreen }) => $fullScreen ? 'none' : 'translate(-50%, -50%)'};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    background-color: ${({ $fullScreen, $backgroundColor }) => $fullScreen ? 'transparent' : ($backgroundColor ?? 'transparent')};

    p {
        width: 500px;
        line-height: 1.5;
        margin: 0;
    }
    `;

const EmptyPage: FC<EmptyPageProps> = (props) => {

    return (
        <Wrapper $fullScreen={props.fullScreen} $backgroundColor={props.backgroundColor}>
            <DIV $backgroundColor={props.backgroundColor} $fullScreen={props.fullScreen}>
                {props.image}
                <h1>{props.title}</h1>
                <p className='px14_400_contrast'>
                    {props.description}
                </p>
                {props.button}
            </DIV>
        </Wrapper>
    );
};

export default EmptyPage;